import { render, staticRenderFns } from "./reimb_list.vue?vue&type=template&id=5880b7a5&scoped=true"
import script from "./reimb_list.vue?vue&type=script&lang=js"
export * from "./reimb_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5880b7a5",
  null
  
)

export default component.exports